import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

const LineChart = ({ applicant, screening, evaluation, interview, interviewHistory, offered, hired, dropout }: any) => {
	const data: any = {
		labels: ["Applicant", "Screening", "Evaluation", "Interview", "Interview History", "Offered", "Hired", "Dropout"],
		datasets: [
			{
				fill: false,
				lineTension: 0.3,
				backgroundColor: '#C4B4F7',
				borderColor: '#005b90',
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				pointBorderColor: '#005b90',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 1,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#005b90',
				pointHoverBorderColor: 'rgba(220,220,220,1)',
				pointHoverBorderWidth: 2,
				pointRadius: 1,
				pointHitRadius: 10,
				data: [applicant, screening, evaluation, interview, interviewHistory, offered, !hired ? 0 : hired, !dropout ? 0 : dropout],
			},
		],
	};



	const options: any = {
		plugins: {
			legend: {
				display: false, // Set display property of legend to false
			},
		},
		scales: {
			y: {
				min: 0,
				max: 100,
			},
		},
		responsive: true,
		maintainAspectRatio: false,
	};
	return (
		<div className='Linestyle'>
			<Line data={data} options={options} />
		</div>
	);
};

export default LineChart;
